import React, { FC } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../img/logo-1.svg";
import { logout } from "../../repositories/PredsenseRepository";
import { usePrivileges } from "../../repositories/hooks/usePrivileges";

interface SidebarItem {
  id: string;
  label: string;
  icon: any; //todo
  link: string;
  requiredPrivilege?: string;
  onClick?: () => void;
  disabled?: boolean;
  hasAccess?: boolean;
  last?: boolean;
}

interface Props {
  items: SidebarItem[];
}

const Sidebar: FC<Props> = ({ items }) => {
  const navigate = useNavigate();
  const privileges = usePrivileges();

  return (
    <div className={"sidebar"}>
      <div className={"logo-sidebar"}>
        <img src={logo} alt="predSense logo" className={"logoImage"} />
      </div>

      <div className={"items"}>
        {items
          .filter((e) => e.hasAccess)
          .map((item) => {
            return (
              <NavLink
                to={item.link}
                key={item.id}
                className={({ isActive }) =>
                  `item ${!item.disabled ? "" : "disabled"} ${
                    isActive ? "active" : ""
                  } ${item?.last ? "last-item" : ""}`
                }
                onClick={(e) => {
                  if (!!item.disabled) e.preventDefault();
                }}
              >
                <div className={"icon"}>
                  <img src={item.icon} alt="" />
                </div>
                <span>{item.label}</span>
              </NavLink>
            );
          })}
      </div>

      <div className="fixedItems">
        {!!privileges.ORGANIZATION_R && (
          <div className="item" onClick={() => navigate("/super")}>
            <span>Settings</span>
          </div>
        )}
        <div className="item logout-button" onClick={logout}>
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
